export const getQueryParam = (url, param) => {
    const queryString = url.split('?')[1];
    if (!queryString) {
        return null;
    }

    const queries = queryString.split('&');
    for (let query = 0; query < queries.length; query += 1) {
        const pair = queries[query].split('=');
        if (pair[0] === param) {
            return pair[1] === undefined ? true : decodeURIComponent(pair[1]);
        }
    }

    return null;
};

export const removeAllParameters = () => {
    const url = new URL(window.location);
    url.search = new URLSearchParams();
    window.location.href = url.href;
};
